import React, { useRef } from "react";

import classes from "./HomeFeaturedIn.module.scss";
import DynamicDots from "../DynamicDots";
import useSliderIndex from "../useSliderIndex";

const HomeFeaturedIn = () => {
  const featuredData = window.homeFeaturedIn || {};
  const homeFeaturedInData = featuredData.items || [];
  const sliderRef = useRef(null);
  const activeIndex = useSliderIndex(sliderRef);
  return (
    <section className={classes.featuredIn}>
      <div className={`custom-container`}>
        <div className={classes.headingSection}>
          <p className={classes.headingLabel}>{featuredData.headingLabel}</p>
          <h2 className={`p-0 ${classes.headingTitle}`}>
            {featuredData.headingTitle}
          </h2>
        </div>
        <div className={`${classes.featuredContents} d-none d-xl-flex`}>
          {homeFeaturedInData.map((item, index) => (
            <a
              href={item.link}
              key={index}
              target="_blank"
              rel="noreferrer"
              className={classes.featuredItem}
            >
              <img
                src={item.image}
                alt={item.alt}
                className={classes.featuredImage}
              />
            </a>
          ))}
        </div>

        <div className={`${classes.mobileSliderWrap} d-xl-none`}>
          <div ref={sliderRef} data-uk-slider="finite: false">
            <div className="uk-position-relative">
              <div className="uk-slider-container uk-light">
                <ul className="uk-slider-items uk-grid">
                  {homeFeaturedInData.map((item, index) => (
                    <li key={index} className="p-0 ">
                      <a
                        href={item.link}
                        target="_blank"
                        rel="noreferrer"
                        className={classes.featuredItem}
                      >
                        <img
                          src={item.image}
                          alt={item.alt}
                          className={classes.featuredImage}
                        />
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <div className={classes.arrowContainer}>
                <a
                  className={`${classes.arrow} uk-position-center-left-out uk-position-small mx-0`}
                  href="#"
                  data-uk-slider-item="previous"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
                    <g clipPath="url(#homeFeaturedInPrev)">
                      <path d="M23.0045 45.5848C10.5287 45.5848 0.41518 35.4713 0.41518 22.9955C0.41518 10.5198 10.5287 0.40625 23.0045 0.40625C35.4802 0.40625 45.5938 10.5198 45.5938 22.9955C45.5938 35.4713 35.4802 45.5848 23.0045 45.5848Z" stroke="#626262" />
                      <path d="M21.4849 16.6971C21.5686 16.4267 21.8557 16.2753 22.1261 16.3589C22.3966 16.4426 22.548 16.7297 22.4643 17.0001L21.9746 16.8486L21.4849 16.6971ZM16.3362 22.9997V23.5122H14.5917L16.0589 22.5686L16.3362 22.9997ZM16.3362 22.9997V22.4871H31.2012V22.9997V23.5122H16.3362V22.9997ZM18.2254 21.7845L18.5027 22.2156L16.6135 23.4308L16.3362 22.9997L16.0589 22.5686L17.9481 21.3534L18.2254 21.7845ZM21.9746 16.8486L22.4643 17.0001C21.799 19.1508 20.3961 20.9977 18.5027 22.2156L18.2254 21.7845L17.9481 21.3534C19.6385 20.2661 20.891 18.6172 21.4849 16.6971L21.9746 16.8486Z" fill="#626262" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M18.8107 25.999C19.9775 26.8761 20.9053 28.0327 21.508 29.3623C21.6248 29.6201 21.9289 29.734 22.1867 29.6172C22.4442 29.5002 22.5582 29.1971 22.4416 28.9395C21.9417 27.8367 21.2416 26.8404 20.381 25.999H18.8107Z" fill="#626262" />
                    </g>
                    <defs><clipPath id="homeFeaturedInPrev"><rect width="46" height="46" fill="white" transform="matrix(-1 0 0 1 46 0)" /></clipPath></defs>
                  </svg>
                </a>
                <a
                  className={`${classes.arrow} uk-position-center-right-out uk-position-small mx-0`}
                  href="#"
                  data-uk-slider-item="next"
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="46" height="46" viewBox="0 0 46 46" fill="none">
                    <g clipPath="url(#homeFeaturedInNext)">
                      <path d="M22.9955 45.5848C35.4713 45.5848 45.5848 35.4713 45.5848 22.9955C45.5848 10.5198 35.4713 0.40625 22.9955 0.40625C10.5198 0.40625 0.40625 10.5198 0.40625 22.9955C0.40625 35.4713 10.5198 45.5848 22.9955 45.5848Z" stroke="#626262" />
                      <path d="M24.5148 16.6971C24.4312 16.4267 24.1441 16.2753 23.8736 16.3589C23.6032 16.4426 23.4518 16.7297 23.5354 17.0001L24.0251 16.8486L24.5148 16.6971ZM29.6636 22.9997V23.5122H31.408L29.9409 22.5686L29.6636 22.9997ZM29.6636 22.9997V22.4871H14.7986V22.9997V23.5122H29.6636V22.9997ZM27.7744 21.7845L27.4971 22.2156L29.3863 23.4308L29.6636 22.9997L29.9409 22.5686L28.0517 21.3534L27.7744 21.7845ZM24.0251 16.8486L23.5354 17.0001C24.2008 19.1508 25.6037 20.9977 27.4971 22.2156L27.7744 21.7845L28.0517 21.3534C26.3613 20.2661 25.1088 18.6172 24.5148 16.6971L24.0251 16.8486Z" fill="#626262" />
                      <path fillRule="evenodd" clipRule="evenodd" d="M27.1893 25.999C26.0225 26.8761 25.0947 28.0327 24.492 29.3623C24.3752 29.6201 24.0711 29.734 23.8133 29.6172C23.5558 29.5002 23.4418 29.1971 23.5584 28.9395C24.0583 27.8367 24.7584 26.8404 25.619 25.999H27.1893Z" fill="#626262" />
                    </g>
                    <defs><clipPath id="homeFeaturedInNext"><rect width="46" height="46" fill="white" /></clipPath></defs>
                  </svg>
                </a>
              </div>

              <DynamicDots total={homeFeaturedInData.length} activeIndex={activeIndex} classes={classes} sliderRef={sliderRef} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFeaturedIn;
